module.exports = __webpack_public_path__ + "static/media/foto_4.c5092631.png";